import { Component, computed, inject, signal } from '@angular/core';
import { SidebarPromoters } from "../sidebar/sidebar-promoters";
import { HeaderPromoters } from "../header/header-promoters";
import { Router, RouterModule } from '@angular/router';
import { PromotersProfileUi} from '@ribera-web/promoters-dashboard-ui';
import { PromotersDashboardTabs } from '../promoters-dashboard-tabs/promoters-dashboard-tabs';
import { HeaderPublicPromoters } from '../header-public/header-public-promoters';
import { Footer } from '@ribera-web/shell';
import { CommonModule } from '@angular/common';
import { AuthSessionPromotersUtil } from '@ribera-web/auth-data-acess';
import { SidebarClient } from '../sidebar-client/sidebar-client'; 
import { ShellDataService } from '@ribera-web/auth-data-acess';
import { SpinnerLoadingService,  } from '@ribera-web/http-loading';
import { RiberaLoaderUi } from '@ribera-web/ribera-loader-ui'
import { MyRewards, BuyRewards } from "@ribera-web/rewards-feature";
import { PromotersWalletTransfer } from "@ribera-web/wallet-feature";

@Component({
  selector: 'lib-shell-promoters',
  imports: [RouterModule, SidebarPromoters, HeaderPromoters, HeaderPublicPromoters, PromotersProfileUi,
    PromotersDashboardTabs, Footer, CommonModule, SidebarClient, RiberaLoaderUi, MyRewards, BuyRewards, PromotersWalletTransfer],
  templateUrl: './shell-promoters.html',
  styleUrl: './shell-promoters.scss',
})
export class ShellPromoters {

  spinner = inject(SpinnerLoadingService);
  private router = inject(Router);
  private authSessionService = inject(AuthSessionPromotersUtil);
  private shellDataService = inject(ShellDataService);

  isDashboardRoute = this.shellDataService.isDashboardRoute;
  viewSidebarRight = this.shellDataService.viewSidebarRight;

  isLoggedIn = computed(() => this.authSessionService.isLoggedIn());
  isPromotor = signal<boolean>(false);

  isCollapsed = signal(false);

  isPromotorTogle = computed(() => this.shellDataService.isPromotorPerfil());

  toggleSidebar(event: boolean) {
    this.isCollapsed.set(event);
  }

  // constructor() {
  //   this.router.events.pipe(
  //     filter(event => event instanceof NavigationEnd),
  //     takeUntilDestroyed() // Aquí Angular sabe perfectamente cuándo destruir este sub
  //   ).subscribe(() => {
  //     this.checkIfIsDashboard();
  //     this.checkIfViewSidebarRight();
  //   });
  //   this.checkIfIsDashboard();
  //   this.checkIfViewSidebarRight();
  // }

  // private checkIfIsDashboard() {
    
  //   const segments = this.router.url.split('?')[0].split('/').filter(s => s !== '');
  
  //   const lastSegment = segments.pop() || '';
    
  //   console.log('Active seteado a:', lastSegment);

  //   const dashboardPaths = [
  //     'dashboard',
  //     'my-data',
  //   ];
    
  //   this.isDashboardRoute.set(dashboardPaths.some(path => lastSegment.includes(path)));
    
  //   console.log('¿Es Dashboard?:', this.isDashboardRoute());
  // }

  // private checkIfViewSidebarRight() {
    
  //   const segments = this.router.url.split('?')[0].split('/').filter(s => s !== '');
  //   const lastSegment = segments.pop() || '';

  //   const pathsWithSidebar = [
  //     'dashboard',
  //     'wallet',
  //     'booking',
  //     'my-benefits'
  //   ];

  //   this.viewSidebarRight.set(pathsWithSidebar.some(path => lastSegment.includes(path)));

  // }
}
